import { tss } from 'tss-react/mui';

export const useWorkStyles = tss.withName('WorkSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.ink.main,
        color: theme.palette.ink.contrastText,
        padding: theme.spacing(14, '6%'),
    },
    inner: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: theme.spacing(6),
        flexWrap: 'wrap',
        gap: theme.spacing(2),
    },
    eyebrow: {
        color: theme.palette.primary.main,
        display: 'block',
        marginBottom: theme.spacing(2),
    },
    disclaimer: {
        color: theme.palette.fog,
        maxWidth: 280,
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
        },
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: '1fr',
        },
    },
    card: {
        position: 'relative',
        borderRadius: 16,
        overflow: 'hidden',
        height: 380,
        border: `1px solid ${theme.palette.lineOnDark}`,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'flex-end',
        padding: theme.spacing(4),
    },
    cardOverlay: {
        position: 'absolute',
        inset: 0,
        zIndex: 0,
    },
    cardVisual: {
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        opacity: 0.9,
    },
    cardScrim: {
        position: 'absolute',
        inset: 0,
        zIndex: 0,
        background: 'linear-gradient(180deg, rgba(17,24,39,0) 30%, rgba(17,24,39,0.95) 100%)',
    },
    cardBadge: {
        position: 'absolute',
        top: theme.spacing(2.5),
        left: theme.spacing(2.5),
        zIndex: 1,
        padding: theme.spacing(0.5, 1.25),
        borderRadius: 999,
        border: `1px solid ${theme.palette.lineOnDark}`,
        backgroundColor: 'rgba(17,24,39,0.6)',
        color: theme.palette.fog,
    },
    cardContent: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
    },
    cardMeta: {
        color: theme.palette.fog,
    },
}));
